/**
 * Safely extract the className string from a DOM element.
 * Handles SVGAnimatedString (SVG elements), null, undefined, and other non-string shapes.
 */
const getElementClassName = (element) => {
  const cn = element?.className;
  if (typeof cn === 'string') return cn;
  if (cn && typeof cn === 'object' && typeof cn.baseVal === 'string') return cn.baseVal;
  return '';
};

export default getElementClassName;
